import { render } from "./ScoreMOCK3.vue?vue&type=template&id=c688a464&scoped=true"
import script from "./ScoreMOCK3.vue?vue&type=script&lang=js"
export * from "./ScoreMOCK3.vue?vue&type=script&lang=js"

import "./ScoreMOCK3.vue?vue&type=style&index=0&id=c688a464&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c688a464"]])

export default __exports__